import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCampaignsPlatformEditAction } from './hooks/useCampaignsPlatformEditAction';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
function CampaignsPlatformEditAction({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id',
  objectId,
  use = 'secondary',
  children
}) {
  const {
    isDisabled,
    showPermissionTooltip,
    onCampaignEdit,
    editActionText
  } = useCampaignsPlatformEditAction({
    objectType,
    assetId,
    crmIdProperty,
    objectId
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !showPermissionTooltip,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaignSelect.noPublishCampaignPermission"
    }),
    children: /*#__PURE__*/_jsx(Button, {
      disabled: isDisabled,
      onClick: onCampaignEdit,
      "data-test-id": "campaigns-platform-edit-action-button",
      use: use,
      children: children || editActionText
    })
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformEditAction);